<template>
  <div class="container">
    <div class="searchForm">
      <common-search-form-wrapper :reset="resetSearch">
        <el-form
          :inline="true"
          :model="searchInfo"
          class="demo-form-inline"
          size="mini"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="学员姓名: " prop="student_id">
                <el-select
                  v-model="searchInfo.student_id"
                  placeholder="请选择"
                  clearable
                  filterable
                  :filter-method="handleSearchStudent"
                  @focus="handleSearchStudent('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in studentList"
                    :key="item.student_id"
                    :label="item.name"
                    :value="item.student_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签到状态: " prop="sign_type">
                <el-radio-group
                  v-model="searchInfo.sign_type"
                  @change="handleSearch"
                >
                  <el-radio-button :label="1">全部</el-radio-button>
                  <el-radio-button :label="3">请假</el-radio-button>
                  <el-radio-button :label="4">未到课</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="班级名称: " prop="class_id">
                <el-select
                  v-model="searchInfo.class_id"
                  :filter-method="handleSearchClassList"
                  @focus="handleSearchClassList('')"
                  @change="handleSearch"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in classNameList"
                    :key="item.class_id"
                    :label="item.name"
                    :value="item.class_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="上课时间: ">
                <common-date-range-selector
                  v-model="searchInfo.lesson_time"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleSearch"
                >
                </common-date-range-selector>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="授课教师: ">
                <common-staff-pull-down
                  :originId.sync="searchInfo.teacher_id"
                  :defaultSelected.sync="searchInfo.teacher_list"
                  :jobIds="[1]"
                  @change="handleSearch"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="排课课程: ">
                <el-select
                  v-model="searchInfo.course_id"
                  clearable
                  filterable
                  placeholder="请选择"
                  :filter-method="handleSearchCourseList"
                  @focus="handleSearchCourseList('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in courseList"
                    :key="item.course_id"
                    :label="item.title"
                    :value="item.course_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="补课状态: ">
                <el-select
                  size="mini"
                  v-model="searchInfo.make_up_status"
                  clearable
                  filterable
                  multiple
                  placeholder="请选择"
                  @change="handleSearch"
                >
                  <el-option label="待补课" key="1" :value="1"></el-option>
                  <el-option label="补课中" key="2" :value="2"></el-option>
                  <el-option label="已完成" key="3" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="星期:">
                <el-select
                  v-model="searchInfo.week_day"
                  filterable
                  placeholder="请选择"
                  @change="handleSearch"
                  clearable
                >
                  <el-option
                    v-for="item in weekList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
    </div>
    <div class="statistics">
      待补课 {{ statistics.make_up_lessons_be_start || "0" }}人次,补课中
      {{ statistics.make_up_lessons_starting || "0" }}人次,已完成
      {{ statistics.make_up_lesson_started || "0" }}人次
    </div>
    <el-table
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      @sort-change="clickSort"
      :default-sort="{ prop: 'class_lesson', order: 'descending' }"
    >
      <el-table-column prop="student.name" label="学员姓名">
        <template slot-scope="scope">
          <div
            class="mwow-green curp"
            @click="goDetail(scope.row.student.student_id)"
          >
            {{ scope.row.student.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="student_status" label="签到状态">
        <template slot-scope="scope">
          <span v-if="scope.row.student_status === 1">到课</span>
          <span v-if="scope.row.student_status === 2">迟到</span>
          <span v-if="scope.row.student_status === 3">请假</span>
          <span v-if="scope.row.student_status === 4">未到</span>
        </template>
      </el-table-column>
      <el-table-column prop="class.name" label="班级名称"> </el-table-column>
      <el-table-column
        prop="class_lesson"
        label="上课时间"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        width="180"
      >
        <template slot-scope="scope">
          {{ scope.row.class_lesson.date }}
          &nbsp;
          {{ weekDate(scope.row.week_day) }}
          &nbsp;
          {{ scope.row.class_lesson.start_time.substring(0, 5) }}
        </template>
      </el-table-column>
      <el-table-column prop="teacher" label="授课教师">
        <template slot-scope="scope">
          <div v-if="scope.row.teacher != null">
            {{
              scope.row.teacher
                .map((item) => {
                  return item.name;
                })
                .join("、" || "-")
            }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column prop="course.title" label="排课课程"> </el-table-column>
      <el-table-column prop="make_up_status" label="补课状态">
        <template slot-scope="scope">
          <span class="mwow-red" v-if="scope.row.make_up_status === 1"
            >待补课</span
          >
          <span class="mwow-yellow" v-if="scope.row.make_up_status === 2"
            >补课中</span
          >
          <span class="mwow-green" v-if="scope.row.make_up_status === 3"
            >已完成</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="上课内容"
        width="280"
        prop="class_lesson_extend.content"
        class-name="classCon"
      >
        <template slot-scope="scope">
          <span>
            {{
              scope.row.class_lesson_extend.content
                ? scope.row.class_lesson_extend.content
                : "-"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <make-up-detail :sid="scope.row.roll_call_student_id">
            <el-button class="mwow-button primary btn-right">查看</el-button>
          </make-up-detail>
          <el-button
            type="text"
            class="mwow-button success"
            v-if="scope.row.make_up_status === 1"
            @click="goMakeUpLessonClass(scope.row)"
            >补课</el-button
          >
          <el-button
            type="text"
            class="mwow-button success"
            v-if="scope.row.make_up_status === 2"
            @click="cancelMakeLesson(scope.row)"
            >取消</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :style="{ float: 'right', padding: '10px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  getLessonRepairListApi,
  lessonRepairCancelApi,
  lessonRepairListStatisticsApi,
} from "@/api/makeUpLessons";
import { PageModule } from "@/store/module/page";
import { courseAccount } from "@/api/rollCallRecord";
import {
  searchStudent,
  getSelectClassList,
  getSelectCourseList,
} from "@/api/globalSearch";
import eventBus from "@/utils/bus";
import makeUpDetail from "./makeUPDetail.vue";
import { mixin } from "@/mixin/tabPageInfoMixin";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  props: ["visible"],
  components: {
    makeUpDetail,
    commonStaffPullDown,
    CommonSearchFormWrapper,
    commonDateRangeSelector,
  },
  mixins: [mixin],
  data() {
    return {
      searchInfo: {
        student_id: "",
        sign_type: 1,
        class_id: "",
        lesson_id: [],
        teacher_id: "",
        course_id: "",
        make_up_status: [],
        lesson_time: [],
        sort_type: "desc",
        sort_field: "lesson_date",
        teacher_list: [],
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 30, 50, 100],
      total: 0,
      studentList: [], // 学员姓名列表
      classNameList: [], // 班级名称列表
      courseList: [], // 排课课程列表
      statistics: {}, // 数量统计
      showMakeUpDetail: false, // 显示详情弹框
      weekList: [
        {
          key: 1,
          value: "周一",
        },
        {
          key: 2,
          value: "周二",
        },
        {
          key: 3,
          value: "周三",
        },
        {
          key: 4,
          value: "周四",
        },
        {
          key: 5,
          value: "周五",
        },
        {
          key: 6,
          value: "周六",
        },
        {
          key: 0,
          value: "周日",
        },
      ],
    };
  },

  created() {
    this.mixinGetPageInfo("makeUpLessonInfo");
    eventBus.$on("cancelMakeUPLessons", () => {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
        list_type: 1,
      });
    });
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
          list_type: 1,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
        list_type: 1,
      });
    }
  },
  methods: {
    resetSearch() {
      this.searchInfo = {
        student_id: "",
        sign_type: 1,
        class_id: "",
        lesson_id: [],
        teacher_id: "",
        course_id: "",
        make_up_status: [],
        lesson_time: [],
        sort_type: "desc",
        sort_field: "lesson_date",
      };
      this.page = 1;
      this.pageSize = 10;
      this.getList({
        page: 1,
        page_size: 10,
        list_type: 1,
      });
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 1000,
        key_word: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
    },
    weekDate(w) {
      const week = ["日", "一", "二", "三", "四", "五", "六"];
      return `(周${week[w]})`;
    },
    handleSearchClassList(v) {
      getSelectClassList({
        page: 1,
        page_size: 1000,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classNameList = res.data.list;
        }
      });
    },
    handleSearchCourseList(v) {
      getSelectCourseList({
        page: 1,
        page_size: 1000,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
    },
    // list_type 翻页不发统计请求
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.student_id) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.sign_type > 1) {
        option.student_status = this.searchInfo.sign_type;
      }
      if (this.searchInfo.class_id) {
        option.class_id = this.searchInfo.class_id;
      }
      if (this.searchInfo.lesson_id) {
        option.lesson_id = this.searchInfo.lesson_id;
      }
      if (this.searchInfo.teacher_id) {
        option.teacher_id = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.course_id) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.make_up_status.length > 0) {
        option.make_up_status = this.searchInfo.make_up_status;
      }
      if (
        this.searchInfo.lesson_time &&
        this.searchInfo.lesson_time.length == 2
      ) {
        option.lesson_start_date = this.searchInfo.lesson_time[0];
        option.lesson_end_date = this.searchInfo.lesson_time[1];
      }
      if (this.searchInfo.sort_type) {
        option.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field) {
        option.sort_field = this.searchInfo.sort_field;
      }
      if (this.searchInfo.week_day === 0 || this.searchInfo.week_day) {
        option.week_day = this.searchInfo.week_day;
      } else {
        option.week_day = -1;
      }
      if (params.list_type === 1) {
        getLessonRepairListApi(option).then((res) => {
          if (res.error_code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
        lessonRepairListStatisticsApi(option).then((res) => {
          if (res.error_code === 0) {
            this.statistics = res.data.statistics;
          }
        });
      } else {
        getLessonRepairListApi(option).then((res) => {
          if (res.error_code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
      }
      this.mixinSavePageInfo("makeUpLessonInfo");
    },
    // 排序
    clickSort(e) {
      if (e.order === "ascending") {
        this.searchInfo.sort_type = "asc";
      } else if (e.order === "descending") {
        this.searchInfo.sort_type = "desc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: this.page,
        page_size: this.pageSize,
        list_type: 1,
      });
    },
    handleSearch(v) {
      this.getList({
        page: 1,
        page_size: this.pageSize,
        list_type: 1,
      });
      this.page = 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList({
        page: 1,
        page_size: val,
        list_type: 2,
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList({
        page: val,
        page_size: this.pageSize,
        list_type: 2,
      });
    },
    // 取消补课
    cancelMakeLesson(s) {
      this.$confirm(
        "取消学员补课，记录将恢复至 “待补课” 状态，确定要取消补课？",
        `取消补课 - ${s.student.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          lessonRepairCancelApi({
            roll_call_student_id: s.roll_call_student_id,
          }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "取消完成",
              });
              eventBus.$emit("cancelMakeUPLessons");
            }
          });
        })
        .catch(() => {});
    },
    goMakeUpLessonClass(info) {
      courseAccount({
        student_id: info.student_id,
        course_id: info.course.course_id,
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.account.completion_status === 2) {
            this.$message({
              type: "error",
              message: "学员已结课无法补课",
            });
            return;
          } else if (res.data.account.stop_status === 2) {
            this.$message({
              type: "error",
              message: "学员停课中",
            });
            return;
          } else if (res.data.account.completion_status === 1) {
            // return;
            this.mixinSavePageInfo("makeUpLessonInfo");
            this.$router.push({
              name: "repairClass",
              query: {
                cid: info.course.course_id,
                sid: info.roll_call_student_id,
                clid: info.class_id,
              },
            });
          }
        }
      });
    },
    goDetail(sid) {
      this.$router.push({
        name: "studyDetails",
        query: {
          id: sid,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  background-color: #ffffff;
  border-radius: 4px;
  position: relative;
  .reset-btn {
    top: 42px !important;
  }
  .statistics {
    display: inline-block;
    background-color: #ffefd7;
    padding: 8px;
    border-radius: 5px;
    color: #5c5d5e;
    margin-bottom: 12px;
  }
}
/deep/ .el-input__icon {
  line-height: 24px;
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
.btn-right {
  margin-right: 12px;
}
/deep/ .classCon {
  .cell {
    width: 23em;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*禁止换行*/
    text-overflow: ellipsis;
  }
}
.curp {
  cursor: pointer;
}
/deep/ .el-form {
  .el-form-item {
    display: flex;
    margin-right: 80px !important;
    .el-form-item__label {
      min-width: 64px;
    }
    .el-select,
    .el-form-item__content {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
}
</style>
